module.exports = __webpack_public_path__ + "img/NielsKlim_Holberg.e684c555.jpg";